import { render, staticRenderFns } from "./report-generator-page.vue?vue&type=template&id=1b016aea"
import script from "./report-generator-page.vue?vue&type=script&lang=js"
export * from "./report-generator-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports